import React, { useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import { BaseTypography } from '../../../components/common';
import { useCommonStyles } from 'src/materialConfig/commonStyles';
import { CountBlockApi } from '../../../api/base/CountBlock';
import { useFetch } from '../../../utils/hooks/useFetch';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';

const getGrTmColumns = (minWidth: string): string =>
  `repeat(auto-fit, minmax(${minWidth}, 1fr))`;

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: getGrTmColumns('315px'),
    gridGap: '20px',
	margin: '40px 250px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: getGrTmColumns('299px'),
      gridGap: '15px',
	  margin: '40px 0px 0 0px',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: getGrTmColumns('280px'),
    },
  },
  root1: {
	position: 'relative',
	textAlign: 'center',
	padding: '30px 0',
	backgroundColor: 'rgba(218, 239, 251, 0.3)',
	boxShadow: '0px 8px 12px rgba(108, 108, 108, 0.15)',
    transition: '200ms',
    borderRadius: '4px',
	marginBottom: '15px',
  },
  highlightedText: {
    color: theme.palette.primary.main,
	fontWeight: 'bold',
  },
  border: {
	left: '0',
    width: '100%',
    bottom: '0',
    height: '6px',
    position: 'absolute',
    background: '#DAEFFB',
    borderRadius: '4px 0px 0px 4px',
  },
}));

export const CountBlockSection: React.FC = () => {
	const classes = useStyles();
	const commonClasses = useCommonStyles();
	const [{ response, isLoading }, doFetch] = useFetch(
    CountBlockApi.getCountBlockData,
  );
  useEffect(() => {
    doFetch();
  }, [doFetch]);
  
  return (
		<div className={classes.root}>
			<div className={classes.root1}>
				<BaseTypography variant="h2">
					<span className={classes.highlightedText}>{response?.data.expert}</span>
				</BaseTypography>
				<BaseTypography variant="h4">
				  Total number of individually verified experts
				</BaseTypography>
				<div className={classes.border} />
			</div>
			<div className={classes.root1}>
				<BaseTypography variant="h2">
					<span className={classes.highlightedText}>{response?.data.journalist}</span>
				</BaseTypography>
				<BaseTypography variant="h4">
				  Total number of journalists
				</BaseTypography>
				<div className={classes.border} />
			</div>
		</div>
  );
};
